// extracted by mini-css-extract-plugin
module.exports = {"badge":"style_badge__1y7uN","circle":"style_circle__8WnAp","dot":"style_dot__1-7zp"};